import http from '../http';

export const getLandingPageBySlug = async (slug) => {
  const response = await http.get(`/v1/landing-page/page/${slug}`);
  return response.data.data;
};

export const getBlog = async (params) => {
  const response = await http.post('/v1/landing-page/blog', params);
  return response.data;
};

export const blogDetailById = async (id) => {
  const response = await http.post(`/v1/landing-page/blog/${id}`);
  return response.data;
};

export const getDentalServices = async (params) => {
  const response = await http.post('/v1/landing-page/dental-service', params);
  return response.data;
};

export const dentalServiceDetailById = async (id) => {
  const response = await http.post(`/v1/landing-page/dental-service/${id}`);
  return response.data;
};

export const createContact = async (params) => {
  const response = await http.post('/v1/landing-page/contact', params);
  return response.data;
};

export const createPatientBooking = async (params) => {
  const response = await http.post('/v1/landing-page/patient-booking', params);
  return response.data;
};
